import OrimbaConfigurator from "./orimba_configurator";

export default function App() {
  return <OrimbaConfigurator />;
}
